import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import Course from "./Course";
import { useLocation } from "react-router-dom";

function Landing(props) {
  const location = useLocation();
  const [testState, setTestState] = useState(null);
  const sizeRef = useRef();

  const classAScrollLocation = useRef();
  const classALeftButton = useRef();
  const classARightButton = useRef();

  const [imageHeight, setImageHeight] = useState();
  const [imageWidth, setImageWidth] = useState();
  const [imageGap, setImageGap] = useState(5);

  const [sliderWidth, setSliderWidth] = useState(0);
  const CARD_WIDTH = 225;
  const unit = CARD_WIDTH + imageGap;

  const updateSliderWidth = () => {
    if (!sizeRef.current) return;

    const parentWidth = sizeRef.current.clientWidth;
    const whole = Math.floor(parentWidth / unit);

    setSliderWidth(Math.max(1, whole) * unit);
  };

  useEffect(() => {
    updateSliderWidth();

    window.addEventListener("resize", updateSliderWidth);
    return () => window.removeEventListener("resize", updateSliderWidth);
  }, [unit]);
  
  const getWholeCardsPerPage = () => {
    const el = classAScrollLocation.current;
    if (!el) return 1;

    const viewportWidth = el.clientWidth; // visible area width in px
    const whole = Math.floor(viewportWidth / unit);

    return Math.max(1, whole); // clamp so it always scrolls at least 1 card
  };
 
  const getListSize = () => {
    if (!sizeRef.current) return;

    const newWidth = sizeRef.current.clientWidth;
    const newHeight = sizeRef.current.clientHeight;

    setImageWidth((newWidth - imageGap * 4) / 5);
    setImageHeight(newHeight);
    };

    useEffect(() => {
      const handleResize = () => {
          if (sizeRef.current) getListSize();
      };

      window.addEventListener("resize", handleResize);
      requestAnimationFrame(() => {
          if (sizeRef.current) getListSize();
    });

    return () => {
        window.removeEventListener("resize", handleResize);
    };
    }, []);

  useEffect(() => {
    axios.get("/extractCourses").then((data) => {
      setTestState(data.data);
    });
    return () => {
      setTestState(null);
    };
  }, []);

  useEffect(() => {
    if (testState) {
    }
  }, [testState]);

  useEffect(() => {
    const width = sizeRef.current.offsetWidth;
    const scrollbarWidth = window.innerWidth - document?.body?.clientWidth;
    setImageWidth((width - imageGap * 4) / 5);

    // ====================================================== //

    if ( classAScrollLocation.current.scrollLeft - classAScrollLocation.current.offsetWidth <=
         -classAScrollLocation.current.offsetWidth
    ) {
      classALeftButton.current.style.display = "none";
    } else {
      classALeftButton.current.style.display = "flex";
    }

    if ( classAScrollLocation.current.scrollLeft + classAScrollLocation.current.offsetWidth >=
         classAScrollLocation.current.scrollWidth
    ) {
      classARightButton.current.style.display = "none";
    } else {
      classARightButton.current.style.display = "flex";
    }

  });


  useEffect(() => { }, [imageWidth]);
    const onClickRightButtonA = () => {
    const el = classAScrollLocation.current;
    if (!el) return;

    const whole = getWholeCardsPerPage();
    const scrollAmount = whole * unit;

    el.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  const onClickLeftButtonA = () => {
    const el = classAScrollLocation.current;
    if (!el) return;

    const whole = getWholeCardsPerPage();
    const scrollAmount = whole * unit;

    el.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  };

  const updateArrowVisibilityA = () => {
    const el = classAScrollLocation.current;
    if (!el || !classALeftButton.current || !classARightButton.current) return;

    const atLeft = el.scrollLeft <= 0;
    const atRight = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

    classALeftButton.current.style.display = atLeft ? "none" : "flex";
    classARightButton.current.style.display = atRight ? "none" : "flex";
  };

  useEffect(() => {
    const el = classAScrollLocation.current;
    if (!el) return;

    updateArrowVisibilityA(); // initial

    el.addEventListener("scroll", updateArrowVisibilityA);
    window.addEventListener("resize", updateArrowVisibilityA);

    return () => {
      el.removeEventListener("scroll", updateArrowVisibilityA);
      window.removeEventListener("resize", updateArrowVisibilityA);
    };
  }, []);

  return (
    <Container>
      <Space />
      <CourseOuterContainer>
        <CourseContainer ref={sizeRef}>
          <CoursesCategory>SAFETY & OPERATOR TRAINING COURSES</CoursesCategory>
          <ButtonsContainer>
            <LeftButton
              onClick={() => onClickLeftButtonA()}
              ref={classALeftButton}
            >
              {"<"}
            </LeftButton>
            <RightButton
              onClick={() => onClickRightButtonA()}
              ref={classARightButton}
            >
              {">"}
            </RightButton>

            <OuterSliderContainer
              ref={classAScrollLocation}
              style={{ width: sliderWidth ? sliderWidth : "100%" }}
            >
              <SliderContainer>                
                <ClassSlider style={{ gap: imageGap }}>
                  {testState ? (
                    testState.map((subData) =>
                      location.state?.users && location.state?.teamId ? (
                        subData?.affiliation.toLowerCase().indexOf("aosh") >= 0 ? (
                          <Course
                            key={subData.id}
                            affiliation={subData.affiliation}
                            id={subData.id}
                            title={subData.name}
                            description={subData.description}
                            price={subData.price}
                            state={subData.state}
                            stImg={subData.stateImg}
                            crsImg={subData.courseImg}
                            stColor={subData.stateColor}
                            teamId={location.state.teamId}
                            users={location.state.users}
                            containerWidth={imageWidth}
                            isCourseAvailable={subData.courseAvailability}
                            promoCodeId={subData.promoCode}
                            stripePriceId={subData.stripePrice}
                          />
                        ) : (
                          <div key={`${subData.id}-hidden`} style={{ display: "none" }} />
                        )
                      ) : subData?.affiliation.toLowerCase().indexOf("aosh") >= 0 ? (
                        <Course
                          key={subData.id}
                          affiliation={subData.affiliation}
                          id={subData.id}
                          title={subData.name}
                          description={subData.description}
                          duration={subData.duration}
                          price={subData.price}
                          state={subData.state}
                          stImg={subData.stateImg}
                          crsImg={subData.courseImg}
                          stColor={subData.stateColor}
                          containerWidth={imageWidth}
                          isCourseAvailable={subData.courseAvailability}
                          promoCodeId={subData.promoCode}
                          stripePriceId={subData.stripePrice}
                        />
                      ) : (
                        <div key={`${subData.id}-hidden`} style={{ display: "none" }} />
                      )
                    )
                  ) : (
                    <div>loading...</div>
                  )}
                </ClassSlider>
              </SliderContainer>
            </OuterSliderContainer>
          </ButtonsContainer>
        </CourseContainer>
      </CourseOuterContainer>
    </Container>
  );
}

export default Landing;

const CourseOuterContainer = styled.div`
  padding: 60px;
`;

const Space = styled.div`
  padding-top: 70px;
`;

const OuterSliderContainer = styled.div`
  scroll-behavior: smooth;
  position: relative;
  height: 300px;
  overflow-x: auto;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::after {
    content: "";
    display: table;
    clear: both;
  }
`;

const ButtonsContainer = styled.div`
  position: relative;
`;

const LeftButton = styled.div`
  cursor: pointer;
  box-shadow: 0px 0px 9px 0px rgb(0 0 0 / 20%);

  position: absolute;
  left: -30px;
  height: 45px;
  width: 45px;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1.7rem;
  top: 45%;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0px 0px 9px 0px rgb(0 0 0 / 50%);
    transform: scale(1.05);
  }
`;
const RightButton = styled.div`
  cursor: pointer;
  box-shadow: 0px 0px 9px 0px rgb(0 0 0 / 20%);

  position: absolute;
  right: -1px;
  height: 45px;
  width: 45px;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.7rem;
  top: 45%;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0px 0px 9px 0px rgb(0 0 0 / 50%);
    transform: scale(1.05);
  }
`;
const SliderContainer = styled.div`
  position: absolute;
  /* overflow-x: auto;
  overflow-y: hidden; */
`;

const ClassSlider = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;

const Container = styled.div`
  /* padding: 60px; */
  background-color: #f2f2f2;
`;
const CourseContainer = styled.div`
  /* box-sizing: border-box;
  padding: 60px; */
`;
const Courses = styled.div`
  /* display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px; */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  grid-gap: 5rem;
  padding: 5rem;
`;

const CoursesCategory = styled.div`
  /* padding-bottom: 35px; */
  margin: 5px 0 10px 0;
  font-weight: 600;
  font-size: 1.2rem;
`;
